import { render, staticRenderFns } from "./EmployeeCohort.vue?vue&type=template&id=1ca9f2e3"
import script from "./EmployeeCohort.vue?vue&type=script&lang=js"
export * from "./EmployeeCohort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports